export default {
      id: "bar-chart-usage",
      viewBox: "0 0 18 20",
      url: "/dist/svg/" + "sprite.svg#bar-chart-usage",
      toString: function () {
        return this.url;
      }
    }